export default {
  trips: (state) => state.trips,
  trip: (state) => state.trip
}